import { useQuery } from "urql";

import {
  GetTradeInsurancesDocument,
  TradeInsuranceFilter,
  TradeInsuranceOrderBy,
} from "../../../graphql/generated.ts";
import { getApiPaginationData } from "../../../utils/api.ts";
import { ApiHookProps } from "../types.ts";

export const useTradeInsurances = ({
  filter,
  orderBy,
  page,
}: ApiHookProps<TradeInsuranceFilter, TradeInsuranceOrderBy>) => {
  const pagination = getApiPaginationData(page);
  return useQuery({
    query: GetTradeInsurancesDocument,
    variables: {
      filter,
      orderBy,
      skip: pagination?.skip,
      take: pagination?.take,
    },
  });
};
